import { Component, OnInit, TemplateRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Param } from '../../models/param';
import { ParamDto } from '../../dto/param.dto';
import { BaseService } from '../../base.service';
import { ParamService } from '../../services/param.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-param',
  templateUrl: './param.component.html',
  styles: []
})
export class ParamComponent implements OnInit {

  title_component: string;
  title_panel: string;
  param: Param = {
    evaluationCost : 0,
    subscriptionFee : 0,
    culqiFee: 0,
    gorentFee: 0
  };
  modalRef: BsModalRef;
  statusEdit: boolean = true;

  constructor(
    private modalService: BsModalService,
    private baseService: BaseService,
    private paramService: ParamService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.title_component = 'Parámetros';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Parámetros';
    this.getDetail();
  }
  
  getDetail(): void {
    this.paramService.getDetail().subscribe(data => {
      //console.log(data);
      this.param = data;
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('Ocurrió un error:', err.error.message);
      } else {
        console.log('Backend devuelto código de estado: ', err.status);
        console.log('Response body:', err.error);
        if (err.error.status === 404) {
          localStorage.setItem('message_404', err.error.detail);
          this.router.navigate(['/dashboard/404']);
        }
      }
    });
  }
  
  modalConfirm(event, templateConfirm: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(templateConfirm, { class: 'modal-sm' });
  }

  confirm(evaluationCost: number, subscriptionFee: string , culqiFee: string ): void {
    const message = 'Sus datos se han actualizado con éxito.';
    const dto = new ParamDto(+evaluationCost, +subscriptionFee , +culqiFee );
    this.paramService.update(dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.baseService.showSuccess(message);
          //this.router.navigate(['/dashboard']);
        }, 1000);
      }
    });
    this.modalRef.hide();
  }
  decline(): void {
    this.modalRef.hide(); 
  }
  
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/param/param.component.ts